import React from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import { Button } from 'components/atoms'
import * as S from './styled'

const modalContainer = document.querySelector('#modalContainer')

const Modal = ({ isOpened, onClose, children, disabled }) => {
  return isOpened
    ? ReactDOM.createPortal(
        <S.ModalContainer>
          <S.ModalDialog>
            <S.ModalContent>
              {children}
              <Button label='Ok' handleClick={onClose} fontSize='15px' isDisabled={disabled} />
            </S.ModalContent>
          </S.ModalDialog>
        </S.ModalContainer>,
        modalContainer
      )
    : null
}

Modal.defaultProps = {
  isOpened: false,
  onClose: () => {},
  children: [],
  disabled: true,
}

Modal.propTypes = {
  isOpened: PropTypes.bool,
  onClose: PropTypes.func,
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  disabled: PropTypes.bool,
}

export default Modal
